// Reserved for future NEXCARTA custom scripts.
document.addEventListener("DOMContentLoaded", () => {

  const header = document.querySelector(".shopify-section-header");

  if (!header) return;

  const handleScroll = () => {
    if (window.scrollY > 20) {
      header.classList.add("is-scrolled");
    } else {
      header.classList.remove("is-scrolled");
    }
  };

  handleScroll();

  window.addEventListener("scroll", handleScroll, {
    passive: true
  });

});
/* ==========================================================
   C-02.2 Apple Hero Parallax
========================================================== */

document.addEventListener("DOMContentLoaded", () => {

  const heroMedia = document.querySelector(".banner__media");

  if (!heroMedia) return;

  const updateParallax = () => {
    const offset = window.pageYOffset * 0.15;
    heroMedia.style.transform = `translateY(${offset}px)`;
  };

  updateParallax();

  window.addEventListener("scroll", updateParallax, {
    passive: true
  });

});
/* =========================================================
   C-02.3 Hero Content Animation
========================================================= */

window.addEventListener("load", () => {
  document.body.classList.add("nx-loaded");
});
/* =========================================================
   C-02.4 Scroll Reveal Animation
========================================================= */

document.addEventListener("DOMContentLoaded", () => {
  const revealItems = document.querySelectorAll(
    ".shopify-section:not(.shopify-section-header)"
  );

  revealItems.forEach((item) => {
    item.classList.add("nx-reveal");
  });

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("is-visible");
        }
      });
    },
    {
      threshold: 0.15,
    }
  );

  revealItems.forEach((item) => observer.observe(item));
});
/* =========================================================
   NEXCARTA Premium Toast
========================================================= */

function nexcartaToast(icon, title, text) {

    const toast = document.getElementById("nexcarta-toast");

    if (!toast) return;

    toast.querySelector(".nexcarta-toast-icon").textContent = icon;
    toast.querySelector(".nexcarta-toast-title").textContent = title;
    toast.querySelector(".nexcarta-toast-text").textContent = text;

    toast.classList.add("show");

    clearTimeout(toast.hideTimer);

    toast.hideTimer = setTimeout(() => {
        toast.classList.remove("show");
    }, 2500);
}
/* =========================================================
   NEXCARTA Wishlist Engine V2
========================================================= */

document.addEventListener("DOMContentLoaded", () => {

    document.addEventListener("click", (e) => {

        const button = e.target.closest(".nexcarta-wishlist-btn");
        if (!button) return;

        e.preventDefault();
        e.stopPropagation();

        const active = button.classList.toggle("is-active");

        if (active) {

            nexcartaToast(
                "❤️",
                "Added to Wishlist",
                "Saved for later shopping."
            );

        } else {

            nexcartaToast(
                "🤍",
                "Removed",
                "Removed from your wishlist."
            );

        }

    });

});
/* =========================================================
   NEXCARTA Share Drawer V2
========================================================= */

document.addEventListener("DOMContentLoaded", () => {

    const drawer = document.getElementById("nexcarta-share-drawer");
    if (!drawer) return;

    const overlay = drawer.querySelector(".nx-share-overlay");
    const closeBtn = drawer.querySelector(".nx-share-close");
    const shareGrid = drawer.querySelector(".nx-share-grid");

    let currentShareUrl = "";

    // ===========================
    // OPEN DRAWER
    // ===========================

    document.addEventListener("click", (e) => {

        const shareBtn = e.target.closest(".nexcarta-share-btn");
        if (!shareBtn) return;

        e.preventDefault();
        e.stopPropagation();

        const card = shareBtn.closest(".card");

        let url = window.location.href;
        let title = document.title;
        let image = "";

        let saleText = "";
        let regularText = "";
        let discountText = "";

        if (card) {

            const img = card.querySelector("img");
            const heading = card.querySelector(".card__heading");
            const link = card.querySelector(".full-unstyled-link");

            const salePrice = card.querySelector(".price-item--sale");
            const regularPrice = card.querySelector(".price-item--regular");
            const discount = card.querySelector(".nexcarta-price-discount");

            image = img ? img.src : "";

            title = heading
                ? heading.textContent.trim()
                : document.title;

            url = link
                ? link.href
                : window.location.href;

            currentShareUrl = url;

            if (salePrice) {
                saleText = salePrice.textContent.trim();
            } else if (regularPrice) {
                saleText = regularPrice.textContent.trim();
            }

            if (regularPrice && salePrice) {
                regularText = regularPrice.textContent.trim();
            }

            if (discount) {
                discountText = discount.textContent.trim() + " OFF";
            }

        } else {

            currentShareUrl = url;

        }

        drawer.querySelector("#nx-share-image").src = image;
        drawer.querySelector("#nx-share-title").textContent = title;
        drawer.querySelector("#nx-share-sale-price").textContent = saleText;
        drawer.querySelector("#nx-share-compare-price").textContent = regularText;
        drawer.querySelector("#nx-share-discount").textContent = discountText;

        try {

            drawer.querySelector("#nx-share-url").textContent =
                new URL(currentShareUrl).hostname.replace("www.", "");

        } catch {

            drawer.querySelector("#nx-share-url").textContent =
                currentShareUrl;

        }

        drawer.classList.add("active");

    });

    // ===========================
    // CLOSE
    // ===========================

    closeBtn.addEventListener("click", () => {
        drawer.classList.remove("active");
    });

    overlay.addEventListener("click", () => {
        document.addEventListener("click", function (e) {

  if (!drawer.classList.contains("show")) return;

  // Open button par click ignore
  if (openBtn.contains(e.target)) return;

  // Drawer ke andar click ignore
  if (drawer.contains(e.target)) return;

  closeDrawer();

});
        drawer.classList.remove("active");
    });

    document.addEventListener("keydown", (e) => {
        if (e.key === "Escape") {
            drawer.classList.remove("active");
        }
    });

    // ===========================
    // SHARE ACTIONS
    // ===========================

    shareGrid.addEventListener("click", (e) => {

        const item = e.target.closest(".nx-share-item");
        if (!item) return;

        const type = item.dataset.share;

        const title =
            document.getElementById("nx-share-title").textContent;

        switch (type) {

            case "copy":

                navigator.clipboard.writeText(currentShareUrl)
                .then(() => {

                    nexcartaToast(
                        "🔗",
                        "Link Copied",
                        "Product link copied successfully."
                    );

                    drawer.classList.remove("active");

                })
                .catch(() => {

                    nexcartaToast(
                        "⚠️",
                        "Copy Failed",
                        "Please copy the link manually."
                    );

                });

            break;

            case "whatsapp":

                window.open(
                    `https://wa.me/?text=${encodeURIComponent(title + " " + currentShareUrl)}`,
                    "_blank"
                );

                drawer.classList.remove("active");

            break;

            case "facebook":

                window.open(
                    `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(currentShareUrl)}`,
                    "_blank"
                );

                drawer.classList.remove("active");

            break;

            case "telegram":

                window.open(
                    `https://t.me/share/url?url=${encodeURIComponent(currentShareUrl)}&text=${encodeURIComponent(title)}`,
                    "_blank"
                );

                drawer.classList.remove("active");

            break;

            case "twitter":

                window.open(
                    `https://twitter.com/intent/tweet?url=${encodeURIComponent(currentShareUrl)}&text=${encodeURIComponent(title)}`,
                    "_blank"
                );

                drawer.classList.remove("active");

            break;

            case "linkedin":

                window.open(
                    `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(currentShareUrl)}`,
                    "_blank"
                );

                drawer.classList.remove("active");

            break;

            case "email":

                window.location.href =
                    `mailto:?subject=${encodeURIComponent(title)}&body=${encodeURIComponent(currentShareUrl)}`;

                drawer.classList.remove("active");

            break;

            case "pinterest":

                window.open(
                    `https://pinterest.com/pin/create/button/?url=${encodeURIComponent(currentShareUrl)}`,
                    "_blank"
                );

                drawer.classList.remove("active");

            break;

        }

    });

});
/* ==========================
   NEXCARTA LOCATION DRAWER
========================== */

document.addEventListener("DOMContentLoaded", () => {

  const openBtn = document.getElementById("nx-open-location");
  const drawer = document.getElementById("nx-location-drawer");
  const overlay = document.getElementById("nx-location-overlay");
  const closeBtn = document.getElementById("nx-close-drawer");

  if (!openBtn || !drawer || !overlay || !closeBtn) {
    console.warn("NEXCARTA: Location drawer elements not found.");
    return;
  }

  /* MOVE DRAWER AND OVERLAY TO BODY */

  if (drawer.parentElement !== document.body) {
    document.body.appendChild(drawer);
  }

  if (overlay.parentElement !== document.body) {
    document.body.appendChild(overlay);
  }

  /* OPEN DRAWER + AUTO-FILL CURRENT LOCATION */

  function openDrawer() {

    drawer.scrollTop = 0;
    drawer.classList.add("show");
    overlay.classList.add("show");
    document.body.style.overflow = "hidden";

    const house = document.getElementById("nx-house");
    const area = document.getElementById("nx-area");
    const postcode = document.getElementById("nx-pincode");
    const city = document.getElementById("nx-city");
    const state = document.getElementById("nx-state");

    // Existing address details ko overwrite nahi karna
    const fields = [house, area, postcode, city, state];

    const formIsBlank = fields.every(field =>
      !field || !field.value.trim()
    );

    if (!formIsBlank) {
      console.log("ℹ️ Existing address detected. Auto-fill skipped.");
      return;
    }

    // Saved current location read karo
    let currentLocation = {};

    try {
      currentLocation = JSON.parse(
        localStorage.getItem("nx_current_location") || "{}"
      );
    } catch (error) {
      console.error("❌ Current location read error:", error);
      return;
    }

    // Location ke available address details
    const areaName =
      currentLocation.road ||
      currentLocation.residential ||
      currentLocation.suburb ||
      currentLocation.neighbourhood ||
      currentLocation.hamlet ||
      currentLocation.quarter ||
      currentLocation.locality ||
      "";

    const postcodeValue = currentLocation.postcode || "";

    const cityValue =
      currentLocation.city ||
      currentLocation.town ||
      currentLocation.village ||
      currentLocation.municipality ||
      currentLocation.city_district ||
      "";

    const stateValue =
      currentLocation.state ||
      currentLocation.state_district ||
      "";

    if (!areaName && !postcodeValue && !cityValue && !stateValue) {
      console.warn("ℹ️ Current location address details are unavailable.");
      return;
    }

    // Fill field and notify existing input listeners
    function setField(field, value) {
      if (!field || !value) return;

      field.value = value;

      field.dispatchEvent(
        new Event("input", { bubbles: true })
      );

      field.dispatchEvent(
        new Event("change", { bubbles: true })
      );
    }

    setField(area, areaName);
    setField(postcode, postcodeValue);
    setField(city, cityValue);
    setField(state, stateValue);

    // House/flat, name and mobile manually enter honge
    console.log("✅ Current location auto-fill result:", {
      area: area?.value || "",
      postcode: postcode?.value || "",
      city: city?.value || "",
      state: state?.value || ""
    });
  }

  /* CLOSE DRAWER */

  function closeDrawer() {

    drawer.classList.remove("show");
    overlay.classList.remove("show");

    const addressForm = document.querySelector(".nx-add-address");

    if (addressForm) {
      addressForm.classList.remove("show");
    }

    document.body.style.overflow = "";
  }

  /* BUTTON EVENTS */

  openBtn.addEventListener("click", function (e) {
    e.preventDefault();
    openDrawer();
  });

  closeBtn.addEventListener("click", closeDrawer);
  overlay.addEventListener("click", closeDrawer);

  /* CLOSE WHEN CLICKING OUTSIDE DRAWER */

  document.addEventListener("pointerdown", function (e) {

    if (!drawer.classList.contains("show")) return;
    if (drawer.contains(e.target)) return;
    if (openBtn.contains(e.target)) return;

    closeDrawer();
  });

  /* CLOSE WITH ESCAPE KEY */

  document.addEventListener("keydown", function (e) {

    if (e.key === "Escape") {
      closeDrawer();
    }

  });

});
/* ==========================================
   FILL ADDRESS FORM
========================================== */

function fillAddressForm(addr = {}) {

  const pincode = document.getElementById("nx-pincode");
  const city = document.getElementById("nx-city");
  const state = document.getElementById("nx-state");
  const area = document.getElementById("nx-area");

  const postcode = addr.postcode || addr.postal_code || "";
  const cityName =
    addr.city ||
    addr.city_district ||
    addr.town ||
    addr.village ||
    addr.municipality ||
    addr.county ||
    "";

  const stateName =
    addr.state ||
    addr.state_district ||
    "";

  const areaName =
    addr.road ||
    addr.residential ||
    addr.suburb ||
    addr.neighbourhood ||
    addr.hamlet ||
    addr.quarter ||
    addr.locality ||
    "";

  if (pincode) {
    pincode.value = postcode;
    pincode.dispatchEvent(new Event("input", { bubbles: true }));
    pincode.dispatchEvent(new Event("change", { bubbles: true }));
  }

  if (city) {
    city.value = cityName;
    city.dispatchEvent(new Event("input", { bubbles: true }));
  }

  if (state) {
    state.value = stateName;
    state.dispatchEvent(new Event("input", { bubbles: true }));
  }

  if (area) {
    area.value = areaName;
    area.dispatchEvent(new Event("input", { bubbles: true }));
  }

}
/* ==========================================
OPEN ADDRESS FORM
========================================== */

function openAddressForm() {

  const addForm = document.querySelector(".nx-add-address");
  const addBtn = document.getElementById("nx-add-address-btn");

  if (!addForm) return;

  addForm.style.display = "block";
  addForm.classList.add("show");

  addForm.scrollIntoView({
    behavior: "smooth",
    block: "start"
  });

  if (addBtn) {
    addBtn.textContent = "✖ Cancel";
  }

}
/* ==========================
   CURRENT LOCATION
========================== */

const currentLocationBtn = document.getElementById("nx-current-location");
const locationText = document.getElementById("nx-location-text");

if (currentLocationBtn && locationText) {

  currentLocationBtn.addEventListener("click", () => {

    if (!navigator.geolocation) {
      alert("Geolocation is not supported by this browser.");
      return;
    }

    currentLocationBtn.disabled = true;
    currentLocationBtn.querySelector("span").textContent = "Getting location...";

    navigator.geolocation.getCurrentPosition(

      async (position) => {

        const lat = position.coords.latitude;
        const lng = position.coords.longitude;

        try {

          const res = await fetch(
            `https://nominatim.openstreetmap.org/reverse?format=jsonv2&lat=${lat}&lon=${lng}`,
            {
              headers: {
                Accept: "application/json"
              }
            }
          );

          if (!res.ok) {
            throw new Error(`HTTP ${res.status}`);
          }
          const data = await res.json();
          const addr = data?.address || {};
          const address =
            `${addr.road || ""}${addr.road ? ", " : ""}${
              addr.city || addr.town || addr.village || ""
            }${addr.postcode ? " - " + addr.postcode : ""}`;

          locationText.textContent = "📍 " + address;

          localStorage.setItem("nx_location", address);

          localStorage.setItem("nx_current_location", JSON.stringify({
  road: addr.road || "",
  suburb:
    addr.suburb ||
    addr.neighbourhood ||
    addr.residential ||
    "",
  city:
    addr.city ||
    addr.town ||
    addr.village ||
    "",
  state:
    addr.state ||
    addr.state_district ||
    "",
  postcode:
    addr.postcode ||
    addr.postal_code ||
    "",
  country:
    addr.country ||
    "",
  countryCode:
    addr.country_code ||
    ""
}));
/* ==========================
   OPEN FORM
========================== */
fillAddressForm(addr);

openAddressForm();

    } catch (e) {

      console.error("Reverse Geocoding Error:", e);
      alert(e.message || "Unable to fetch address.");

    } finally {

      currentLocationBtn.disabled = false;
      currentLocationBtn.querySelector("span").textContent =
        "Use my current location";

    }

  },

  (error) => {

    console.error("Geolocation Error:", error);

    switch (error.code) {

      case error.PERMISSION_DENIED:
        alert("Location permission denied.");
        break;

      case error.POSITION_UNAVAILABLE:
        alert("Location information unavailable.");
        break;

      case error.TIMEOUT:
        alert("Location request timed out.");
        break;

      default:
        alert("Unknown location error.");

    }

    currentLocationBtn.disabled = false;
    currentLocationBtn.querySelector("span").textContent =
      "Use my current location";

  },

  {
    enableHighAccuracy: true,
    timeout: 15000,
    maximumAge: 0
  }

);

  });

  const savedLocation = localStorage.getItem("nx_location");

  if (savedLocation) {
    locationText.textContent = "📍 " + savedLocation;
  }

}
/* ==========================================
   NEXCARTA LOCATION SEARCH
========================================== */

document.addEventListener("DOMContentLoaded", () => {

  const searchInput =
    document.getElementById("nx-location-search");

  const resultsBox =
    document.getElementById("nx-search-results");

  if (!searchInput || !resultsBox) return;

  let timer;

  searchInput.addEventListener("input", function () {

    clearTimeout(timer);

    const keyword = this.value.trim();

    if (keyword.length < 3) {

      resultsBox.classList.remove("show");
      resultsBox.innerHTML = "";

      return;
    }

    timer = setTimeout(async () => {

      try {

        const res = await fetch(
          `https://nominatim.openstreetmap.org/search?format=jsonv2&q=${encodeURIComponent(keyword)}&limit=5`,
          {
            headers: {
              Accept: "application/json"
            }
          }
        );

        if (!res.ok) {
          throw new Error(
            `Location search failed: HTTP ${res.status}`
          );
        }

        const data = await res.json();

        resultsBox.innerHTML = "";

        if (!data.length) {

          resultsBox.innerHTML =
            `<div class="nx-search-item">No location found</div>`;

          resultsBox.classList.add("show");

          return;
        }

        data.forEach(item => {

          const div =
            document.createElement("div");

          div.className =
            "nx-search-item";

          div.textContent =
            item.display_name;

          div.addEventListener(
            "click",
            () => {
              fillLocation(item);
            }
          );

          resultsBox.appendChild(div);

        });

        resultsBox.classList.add("show");

      } catch (err) {

        console.error(
          "NEXCARTA Location Search Error:",
          err
        );

        resultsBox.innerHTML =
          `<div class="nx-search-item">Unable to search location</div>`;

        resultsBox.classList.add("show");

      }

    }, 300);

  });

  async function fillLocation(item) {

    resultsBox.classList.remove("show");

    searchInput.value =
      item.display_name;

    try {

      const res = await fetch(
        `https://nominatim.openstreetmap.org/reverse?format=jsonv2&lat=${item.lat}&lon=${item.lon}`,
        {
          headers: {
            Accept: "application/json"
          }
        }
      );

      if (!res.ok) {
        throw new Error(
          `Reverse geocoding failed: HTTP ${res.status}`
        );
      }

      const data =
        await res.json();

      const addr =
        data.address || {};

      /* ==========================
         FILL ADDRESS FORM
      ========================== */

      fillAddressForm(addr);

      openAddressForm();

      /* ==========================
         PRODUCT LOCATION DISPLAY
      ========================== */

      const locationText =
        document.getElementById(
          "nx-location-text"
        );

      if (locationText) {

        locationText.textContent =
          "📍 " + item.display_name;
      }

      /* ==========================
         SAVE LOCATION
      ========================== */

      localStorage.setItem(
        "nx_location",
        item.display_name
      );

      /* ==========================
         SAVE INTERNATIONAL LOCATION
      ========================== */

      localStorage.setItem(
        "nx_current_location",
        JSON.stringify({

          road:
            addr.road ||
            "",

          suburb:
            addr.suburb ||
            addr.neighbourhood ||
            addr.residential ||
            "",

          city:
            addr.city ||
            addr.town ||
            addr.village ||
            addr.municipality ||
            addr.county ||
            "",

          state:
            addr.state ||
            addr.state_district ||
            "",

          postcode:
            addr.postcode ||
            addr.postal_code ||
            "",

          country:
            addr.country ||
            "",

          countryCode:
            addr.country_code ||
            ""

        })
      );

      console.log(
        "NEXCARTA Location Selected:",
        {
          displayName:
            item.display_name,

          country:
            addr.country || "",

          countryCode:
            addr.country_code || "",

          postcode:
            addr.postcode ||
            addr.postal_code ||
            "",

          city:
            addr.city ||
            addr.town ||
            addr.village ||
            "",

          state:
            addr.state ||
            ""
        }
      );

    } catch (err) {

      console.error(
        "NEXCARTA Reverse Geocoding Error:",
        err
      );

    } finally {

      resultsBox.innerHTML = "";

      resultsBox.classList.remove("show");

    }
  }

});
/* ==========================================
   ADD ADDRESS TOGGLE
========================================== */

document.addEventListener("DOMContentLoaded", () => {

  const addBtn = document.getElementById("nx-add-address-btn");
  const addForm = document.querySelector(".nx-add-address");

  if (!addBtn || !addForm) return;
  renderAddresses();

  // By default form hidden
  addForm.classList.remove("show");
  addForm.style.display = "none";

  addBtn.addEventListener("click", () => {

    const opened = addForm.classList.contains("show");

    if (opened) {

      addForm.classList.remove("show");
      addForm.style.display = "none";
      addBtn.textContent = "➕ Add New Address";

    } else {

      addForm.classList.add("show");
      addForm.style.display = "block";
      addBtn.textContent = "✖ Cancel";

      addForm.scrollIntoView({
        behavior: "smooth",
        block: "start"
      });

    }

  });

});
/* ==========================================
   ADDRESS MANAGER V1
========================================== */

document.addEventListener("DOMContentLoaded", () => {

  const saveBtn = document.getElementById("nx-save-address");

  if (!saveBtn) return;

  saveBtn.addEventListener("click", saveAddress);
});
/* ==========================================
   RENDER SAVED ADDRESSES
========================================== */

function renderAddresses() {

  const list = document.getElementById("nx-address-list");

  if (!list) return;

  const addresses =
    JSON.parse(localStorage.getItem("nx_addresses")) || [];

  list.innerHTML = "";

  if (!addresses.length) {

    list.innerHTML = `
      <div class="nx-empty-address">
        No Saved Address
      </div>
    `;

    return;

  }

 addresses.forEach(address => {

  list.innerHTML += `

<div class="nx-address-card ${
  address.isSelected ? "selected" : ""
}">

<div class="nx-address-header">
      <strong>
        ${address.type}

        ${
          address.isDefault
            ? '<span class="nx-default">Default</span>'
            : ''
        }

      </strong>

    </div>

    <div class="nx-address-body">

      <div>${address.name}</div>

      <div>
        ${address.house},
        ${address.area}
      </div>

      <div>
        ${address.city},
        ${address.state}
        -
        ${address.pincode}
      </div>

      <div>
        📞 ${address.mobile}
      </div>

    </div>

    <div class="nx-address-actions">

  ${
    !address.isSelected
      ? `
      <button
        class="nx-deliver-address"
        data-id="${address.id}">
        📍 Deliver Here
      </button>
      `
      : `
      <button
        class="nx-selected-address"
        disabled>
        ✅ Delivering Here
      </button>
      `
  }

  ${
    !address.isDefault
      ? `
      <button
        class="nx-default-address"
        data-id="${address.id}">
        ⭐ Make Default
      </button>
      `
      : ""
  }

  <button
    class="nx-edit-address"
    data-id="${address.id}">
    ✏ Edit
  </button>

  <button
    class="nx-delete-address"
    data-id="${address.id}">
    🗑 Delete
  </button>

</div>

  </div>

  `;

});
/* ==========================================
   EDIT ADDRESS
========================================== */

function editAddress(id) {

  const addresses =
    JSON.parse(localStorage.getItem("nx_addresses")) || [];

  const address = addresses.find(
    item => item.id == id
  );

  if (!address) return;

  document.getElementById("nx-name").value = address.name;
  document.getElementById("nx-mobile").value = address.mobile;
  document.getElementById("nx-house").value = address.house;
  document.getElementById("nx-area").value = address.area;
  document.getElementById("nx-landmark").value = address.landmark;
  document.getElementById("nx-pincode").value = address.pincode;
  document.getElementById("nx-city").value = address.city;
  document.getElementById("nx-state").value = address.state;
  document.getElementById("nx-address-type").value = address.type;

  editingAddressId = id;

const saveBtn = document.getElementById("nx-save-address");

if (saveBtn) {
  saveBtn.textContent = "Update Address";
}
  openAddressForm();

}
document.querySelectorAll(".nx-delete-address")
.forEach(button => {

  button.addEventListener("click", () => {

    deleteAddress(button.dataset.id);

  });

});
document.querySelectorAll(".nx-edit-address").forEach(button => {

  button.addEventListener("click", () => {

    editAddress(button.dataset.id);

  });

});
document.querySelectorAll(".nx-default-address")
.forEach(button => {

  button.addEventListener("click", () => {

    setDefaultAddress(Number(button.dataset.id));

  });

});
document.querySelectorAll(".nx-deliver-address")
.forEach(button => {

  button.addEventListener("click", () => {

    selectDeliveryAddress(button.dataset.id);

  });

});
document.querySelectorAll(".nx-address-card")
.forEach((card, index) => {

    card.addEventListener("click", () => {

        selectAddress(addresses[index].id);

    });

});
}
/* ==========================================
   EDIT MODE
========================================== */

let editingAddressId = null;
/* ==========================================
   DELETE ADDRESS
========================================== */

function deleteAddress(id) {

  const confirmDelete = confirm(
    "Are you sure you want to delete this address?"
  );

  if (!confirmDelete) return;

  let addresses =
    JSON.parse(localStorage.getItem("nx_addresses")) || [];

  addresses = addresses.filter(
    address => address.id != id
  );

  // Agar default address delete ho gaya aur list me address bacha hai
  if (
    addresses.length &&
    !addresses.some(address => address.isDefault)
  ) {
    addresses[0].isDefault = true;
  }

  localStorage.setItem(
    "nx_addresses",
    JSON.stringify(addresses)
  );

  renderAddresses();

}
/* ==========================================
   SET DEFAULT ADDRESS
========================================== */

function setDefaultAddress(id) {

  let addresses =
    JSON.parse(localStorage.getItem("nx_addresses")) || [];

  addresses = addresses.map(address => ({

    ...address,

    isDefault: address.id == id

  }));

  localStorage.setItem(
    "nx_addresses",
    JSON.stringify(addresses)
  );

  renderAddresses();

}
/* ==========================================
   SELECT DELIVERY ADDRESS
========================================== */

function selectDeliveryAddress(id) {

  let addresses =
    JSON.parse(localStorage.getItem("nx_addresses")) || [];

  if (!addresses.length) {
    alert("No saved address found.");
    return;
  }

  addresses = addresses.map(address => ({

    ...address,

    isSelected: String(address.id) === String(id)

  }));

  localStorage.setItem(
    "nx_addresses",
    JSON.stringify(addresses)
  );

  const selectedAddress = addresses.find(
    address => String(address.id) === String(id)
  );

  if (!selectedAddress) {
    return;
  }

  updateDeliveryDetails(selectedAddress);

updateProductDeliveryBox(selectedAddress);

updateCODAvailability(selectedAddress);

updateDeliveryServiceability(selectedAddress);

updateDeliveryDate(selectedAddress);

updateDeliverySummary(selectedAddress)

renderAddresses();

  console.log(
    "Selected Delivery Address:",
    selectedAddress
  );

}
/* ==========================================
   UPDATE DELIVERY DETAILS
========================================== */

function updateDeliveryDetails(address) {

  const deliveryDetails =
    document.getElementById("nx-delivery-details");

  const status =
    document.getElementById("nx-delivery-status");

  const name =
    document.getElementById("nx-delivery-name");

  const addressLine =
    document.getElementById("nx-delivery-address-line");

  const cityState =
    document.getElementById("nx-delivery-city-state");

  const pincode =
    document.getElementById("nx-delivery-pincode");

  if (!deliveryDetails) return;

  if (status) {
    status.textContent = "✓ Delivering Here";
  }

  if (name) {
    name.textContent = address.name || "";
  }

  if (addressLine) {
    addressLine.textContent =
      `${address.house || ""}, ${address.area || ""}`;
  }

  if (cityState) {
    cityState.textContent =
      `${address.city || ""}, ${address.state || ""}`;
  }

  if (pincode) {
    pincode.textContent =
      address.pincode
        ? `PIN Code: ${address.pincode}`
        : "";
  }

  deliveryDetails.style.display = "block";
}
/* ==========================================
   UPDATE PRODUCT DELIVERY BOX
========================================== */

function updateProductDeliveryBox(address) {

  const locationText =
    document.getElementById("nx-location-text");

  if (!locationText) return;

  const parts = [];

  if (address.house) {
    parts.push(address.house);
  }

  if (address.area) {
    parts.push(address.area);
  }

  if (address.city) {
    parts.push(address.city);
  }

  if (address.pincode) {
    parts.push(address.pincode);
  }

  const deliveryLocation = parts.join(", ");

  locationText.textContent =
    deliveryLocation
      ? "📍 " + deliveryLocation
      : "📍 Delivery location selected";

  console.log(
    "Product Delivery Box Updated:",
    address
  );

}
/* ==========================================
   COD AVAILABILITY
========================================== */

function updateCODAvailability(address) {

  const deliveryBox =
    document.querySelector(".nx-features");

  if (!deliveryBox) return;

  const codItem =
    [...deliveryBox.children].find(item =>
      item.textContent.includes("Cash on Delivery")
    );

  if (!codItem) return;

  /*
    Temporary serviceability list.
    Baad me actual courier/shipping API se replace karenge.
  */

  const codPincodes = [
    "203203",
    "201001",
    "110001",
    "110002",
    "250001",
    "201301"
  ];

  const isCODAvailable =
    codPincodes.includes(String(address.pincode));

  if (isCODAvailable) {

    codItem.textContent =
      "💵 Cash on Delivery Available";

    codItem.dataset.codAvailable = "true";

  } else {

    codItem.textContent =
      "🚫 Cash on Delivery Not Available";

    codItem.dataset.codAvailable = "false";

  }

  console.log(
    "COD Status:",
    isCODAvailable ? "Available" : "Not Available",
    "PIN:",
    address.pincode
  );
}
/* ==========================================
   DELIVERY SERVICEABILITY
========================================== */

function updateDeliveryServiceability(address) {
  return;
}

/* ==========================================
   UPDATE DELIVERY DATE
========================================== */

function updateDeliveryDate(address) {

  const dateElement =
    document.getElementById("nx-delivery-date");

  if (!dateElement) return;

  // Shopify shipping rate:
  // Standard Shipping = 5–8 business days
  const minDays = 5;
  const maxDays = 8;

  const addBusinessDays = (startDate, days) => {

    const result = new Date(startDate);
    let added = 0;

    while (added < days) {

      result.setDate(result.getDate() + 1);

      const day = result.getDay();

      // Sunday = 0, Saturday = 6
      if (day !== 0 && day !== 6) {
        added++;
      }
    }

    return result;
  };

  const today = new Date();

  const minDate =
    addBusinessDays(today, minDays);

  const maxDate =
    addBusinessDays(today, maxDays);

  const options = {
    weekday: "short",
    day: "numeric",
    month: "short"
  };

  const minText =
    minDate.toLocaleDateString(
      "en-IN",
      options
    );

  const maxText =
    maxDate.toLocaleDateString(
      "en-IN",
      options
    );

  dateElement.textContent =
    `${minText} – ${maxText}`;

  console.log(
    "✅ Delivery Date Updated:",
    `${minText} – ${maxText}`,
    "Country:",
    address?.country || "",
    "Country Code:",
    address?.countryCode || "",
    "Postcode:",
    address?.postcode || address?.pincode || ""
  );
}

/* ==========================================
   UPDATE DELIVERY SUMMARY
========================================== */

function updateDeliverySummary(address) {

  const summary =
    document.getElementById("nx-delivery-summary");

  const status =
    document.getElementById("nx-delivery-summary-status");

  const addressText =
    document.getElementById("nx-delivery-summary-address");

  if (!summary || !status || !addressText) {
    return;
  }

  status.textContent =
    "✓ Delivering to selected address";

  const parts = [];

  if (address.house) {
    parts.push(address.house);
  }

  if (address.area) {
    parts.push(address.area);
  }

  if (address.city) {
    parts.push(address.city);
  }

  if (address.pincode) {
    parts.push(address.pincode);
  }

  addressText.textContent =
    parts.join(", ");

  summary.style.display = "flex";

  console.log(
    "Delivery Summary Updated:",
    address
  );
}

/* ==========================================
   RESTORE SELECTED DELIVERY ADDRESS
========================================== */

function restoreSelectedDeliveryAddress() {

  const addresses =
    JSON.parse(
      localStorage.getItem("nx_addresses") || "[]"
    );

  const selectedAddress =
    addresses.find(
      address => address.isSelected === true
    );

  // ==========================================
  // 1. SAVED / SELECTED ADDRESS
  // ==========================================

  if (selectedAddress) {

    updateDeliveryDetails(selectedAddress);
    updateProductDeliveryBox(selectedAddress);
    updateCODAvailability(selectedAddress);
    updateDeliveryServiceability(selectedAddress);
    updateDeliveryDate(selectedAddress);
    updateDeliverySummary(selectedAddress);

    console.log(
      "✅ Restored Saved Delivery Address:",
      selectedAddress
    );

    return;
  }

  // ==========================================
  // 2. FALLBACK → CURRENT LOCATION
  // ==========================================

  const currentLocation =
    JSON.parse(
      localStorage.getItem("nx_current_location") || "{}"
    );

  if (
    !currentLocation ||
    (
      !currentLocation.country &&
      !currentLocation.city &&
      !currentLocation.postcode
    )
  ) {

    console.log(
      "ℹ️ No saved address or current location found."
    );

    return;
  }

  const fallbackAddress = {

    name: "",

    mobile: "",

    house: "",

    area:
      currentLocation.suburb ||
      "",

    landmark: "",

    pincode:
      currentLocation.postcode ||
      "",

    postcode:
      currentLocation.postcode ||
      "",

    city:
      currentLocation.city ||
      "",

    state:
      currentLocation.state ||
      "",

    type: "Current Location",

    country:
      currentLocation.country ||
      "",

    countryCode:
      String(
        currentLocation.countryCode ||
        currentLocation.country_code ||
        ""
      ).toLowerCase()
  };

  // ==========================================
  // UPDATE DELIVERY UI FROM CURRENT LOCATION
  // ==========================================

  updateProductDeliveryBox(fallbackAddress);

  updateDeliveryDate(fallbackAddress);

  console.log(
    "✅ Restored Current Location:",
    fallbackAddress
  );
}


/* ==========================================
   RESTORE ON PAGE LOAD
========================================== */

document.addEventListener(
  "DOMContentLoaded",
  () => {
    restoreSelectedDeliveryAddress();
  }
);
 /* ==========================================
SELECT ADDRESS
========================================== */

function selectAddress(id){

    let addresses =
    JSON.parse(localStorage.getItem("nx_addresses")) || [];

    addresses = addresses.map(address => ({

        ...address,

        isSelected: address.id == id

    }));

    localStorage.setItem(
        "nx_addresses",
        JSON.stringify(addresses)
    );

    renderAddresses();

}
function saveAddress() {

  const rawMobile =
    document.getElementById("nx-mobile")?.value.trim() || "";

  const rawZip =
    document.getElementById("nx-pincode")?.value.trim() || "";

  const currentLocation =
    JSON.parse(
      localStorage.getItem("nx_current_location") || "{}"
    );

  const country =
    currentLocation.country || "";

  const countryCode =
    String(
      currentLocation.countryCode ||
      currentLocation.country_code ||
      ""
    ).toLowerCase();

  const address = {

    name:
      document.getElementById("nx-name")?.value.trim() || "",

    mobile:
      rawMobile,

    house:
      document.getElementById("nx-house")?.value.trim() || "",

    area:
      document.getElementById("nx-area")?.value.trim() || "",

    landmark:
      document.getElementById("nx-landmark")?.value.trim() || "",

    pincode:
      rawZip,

    city:
      document.getElementById("nx-city")?.value.trim() || "",

    state:
      document.getElementById("nx-state")?.value.trim() || "",

    type:
      document.getElementById("nx-address-type")?.value || "Home",

    country:
      country,

    countryCode:
      countryCode
  };

  /* ==========================
     VALIDATION
  ========================== */

  if (!address.name) {
    alert("Please enter your full name.");
    return;
  }

  if (!address.house) {
    alert("Please enter your street address.");
    return;
  }

  if (!address.city) {
    alert("Please enter City.");
    return;
  }

  if (!address.state) {
    alert("Please enter State / Province / Region.");
    return;
  }

  /* ==========================
     INTERNATIONAL PHONE
  ========================== */

  const mobileDigits =
    address.mobile.replace(/\D/g, "");

  if (
    mobileDigits.length < 7 ||
    mobileDigits.length > 15
  ) {
    alert("Please enter a valid international phone number.");
    return;
  }

  address.mobile = mobileDigits;

  /* ==========================
     POSTAL / ZIP
  ========================== */

  address.pincode =
    address.pincode.trim();

  if (!address.pincode) {
    alert("Please enter Postal / ZIP Code.");
    return;
  }

  /* ==========================
     COUNTRY REQUIRED
  ========================== */

  if (!address.country) {
    alert("Please select your delivery location first.");
    return;
  }

  /* ==========================
     SAVE ADDRESS
  ========================== */

  address.id = Date.now();

  address.isDefault = false;

  let addresses =
    JSON.parse(
      localStorage.getItem("nx_addresses")
    ) || [];

  if (addresses.length === 0) {
    address.isDefault = true;
  }

  if (editingAddressId) {

    address.id =
      Number(editingAddressId);

    address.isDefault =
      addresses.find(
        item =>
          item.id == editingAddressId
      )?.isDefault || false;

    addresses =
      addresses.map(
        item =>
          item.id == editingAddressId
            ? address
            : item
      );

    editingAddressId = null;

    const saveBtn =
      document.getElementById(
        "nx-save-address"
      );

    if (saveBtn) {
      saveBtn.textContent =
        "Save Address";
    }

  } else {

    addresses.push(address);

  }

  localStorage.setItem(
    "nx_addresses",
    JSON.stringify(addresses)
  );

  alert(
    "Address Saved Successfully."
  );

  renderAddresses();

  console.log(
    "Saved International Address:",
    address
  );

  console.log(
    "All Saved Addresses:",
    addresses
  );
}
/* ==========================================
   BUY NOW — ADDRESS → CHECKOUT
========================================== */

window.nxBuyNowGuard = true;

document.addEventListener("click", function (e) {

  const btn = e.target.closest(".buy-now-button");

  if (!btn) return;

  const addresses =
    JSON.parse(localStorage.getItem("nx_addresses")) || [];

  const selectedAddress =
    addresses.find(
      address => address.isSelected === true
    );

  /* ==========================================
     NO SELECTED ADDRESS
  ========================================== */

  if (!selectedAddress) {

    e.preventDefault();
    e.stopImmediatePropagation();

    alert(
      "Please select a delivery address first."
    );

    const locationButton =
      document.getElementById("nx-open-location");

    if (locationButton) {
      locationButton.click();
    }

    return;
  }

  /* ==========================================
     DELIVERY SERVICEABILITY
  ========================================== */

  const serviceablePincodes = [
    "203203",
    "201001",
    "110001",
    "110002",
    "250001",
    "201301"
  ];

  const isServiceable =
    serviceablePincodes.includes(
      String(selectedAddress.pincode)
    );

  if (!isServiceable) {

    e.preventDefault();
    e.stopImmediatePropagation();

    alert(
      "Delivery is not available for PIN Code " +
      selectedAddress.pincode
    );

    return;
  }

  /* ==========================================
     PRODUCT FORM
  ========================================== */

  const form = btn.closest("form");

  if (!form) {

    e.preventDefault();
    e.stopImmediatePropagation();

    console.error(
      "Buy Now Error: Product form not found."
    );

    return;
  }

  const variantInput =
    form.querySelector('input[name="id"]');

  if (!variantInput) {

    e.preventDefault();
    e.stopImmediatePropagation();

    console.error(
      "Buy Now Error: Variant ID not found."
    );

    return;
  }

  const variantId = variantInput.value;

  /* ==========================================
     BUILD CHECKOUT PERMALINK
  ========================================== */

  const checkoutParams =
    new URLSearchParams();

  checkoutParams.set(
    "checkout[shipping_address][first_name]",
    selectedAddress.name
  );

  checkoutParams.set(
    "checkout[shipping_address][address1]",
    `${selectedAddress.house}, ${selectedAddress.area}`
  );

  checkoutParams.set(
    "checkout[shipping_address][city]",
    selectedAddress.city
  );

  checkoutParams.set(
    "checkout[shipping_address][province]",
    selectedAddress.state
  );

  checkoutParams.set(
    "checkout[shipping_address][country]",
    "India"
  );

  checkoutParams.set(
    "checkout[shipping_address][zip]",
    selectedAddress.pincode
  );

  const checkoutUrl =
    `/cart/${variantId}:1?${checkoutParams.toString()}`;

  /* ==========================================
     STOP ORIGINAL GLOBAL.JS BUY NOW
     
     IMPORTANT:
     This prevents double cart addition.
  ========================================== */

  e.preventDefault();
  e.stopImmediatePropagation();

  console.log(
    "Buy Now → Selected Address:",
    selectedAddress
  );

  console.log(
    "Buy Now → Checkout URL:",
    checkoutUrl
  );

  /* ==========================================
     GO DIRECTLY TO CHECKOUT
  ========================================== */

  window.location.href = checkoutUrl;

}, true);
/* ==========================================
   NEXCARTA C-03.10 PREMIUM IMAGE ZOOM
========================================== */
(() => {
  "use strict";

  if (window.nxPremiumImageZoomLoaded) return;
  window.nxPremiumImageZoomLoaded = true;

  const STYLE_ID = "nx-premium-image-zoom-style";

  function addZoomStyles() {
    if (document.getElementById(STYLE_ID)) return;

    const style = document.createElement("style");
    style.id = STYLE_ID;

    style.textContent = `
      @media (hover: hover) and (pointer: fine) {
        .product__media-wrapper .product__media {
          overflow: hidden !important;
        }

        .product__media-wrapper
        .product__media
        img.image-magnify-lightbox {
          will-change: transform, transform-origin;
          transform: scale(1);
          transform-origin: 50% 50%;
          transition:
            transform 500ms cubic-bezier(0.22, 1, 0.36, 1);
        }
      }

      @media (hover: none), (pointer: coarse) {
        .product__media-wrapper
        .product__media
        img.image-magnify-lightbox {
          transform: none !important;
          transition: none !important;
        }
      }
    `;

    document.head.appendChild(style);
  }

  function setupImage(media) {
    if (!media) return;

    const img = media.querySelector(
      "img.image-magnify-lightbox"
    );

    if (!img) return;

      // C-03.10 — MOBILE SAFETY
  const isTouchDevice =
    window.matchMedia("(hover: none)").matches ||
    window.matchMedia("(pointer: coarse)").matches;

  if (isTouchDevice) {
    return;
  }

    if (media.dataset.nxPremiumZoomReady === "true") {
      return;
    }

    media.dataset.nxPremiumZoomReady = "true";

    let targetX = 50;
    let targetY = 50;

    let currentX = 50;
    let currentY = 50;

    let frame = null;
    let hovering = false;

    function animate() {
      if (!hovering) {
        frame = null;
        return;
      }

      currentX +=
        (targetX - currentX) * 0.14;

      currentY +=
        (targetY - currentY) * 0.14;

      img.style.transformOrigin =
        `${currentX}% ${currentY}%`;

      frame = requestAnimationFrame(animate);
    }

    function startAnimation() {
      if (!frame) {
        frame = requestAnimationFrame(animate);
      }
    }

    function onEnter() {
      hovering = true;

      img.style.transform = "scale(1.14)";

      startAnimation();
    }

    function onMove(event) {
      const rect = media.getBoundingClientRect();

      if (!rect.width || !rect.height) return;

      targetX =
        ((event.clientX - rect.left) / rect.width) * 100;

      targetY =
        ((event.clientY - rect.top) / rect.height) * 100;

      targetX = Math.max(
        0,
        Math.min(100, targetX)
      );

      targetY = Math.max(
        0,
        Math.min(100, targetY)
      );

      startAnimation();
    }

    function onLeave() {
      hovering = false;

      if (frame) {
        cancelAnimationFrame(frame);
        frame = null;
      }

      img.style.transform = "scale(1)";

      window.setTimeout(() => {
        if (!hovering) {
          img.style.transformOrigin = "50% 50%";

          currentX = 50;
          currentY = 50;
          targetX = 50;
          targetY = 50;
        }
      }, 520);
    }

    function onClick(event) {
  const opener = media.closest(
    ".product__modal-opener"
  );

  if (!opener) {
    console.warn(
      "C-03.10: Modal opener not found."
    );
    return;
  }

  const modalButton = opener.querySelector(
    ".product__media-toggle.product__media-zoom-lightbox"
  );

  if (!modalButton) {
    console.warn(
      "C-03.10: Shopify modal button not found."
    );
    return;
  }

  console.log(
    "C-03.10: Image click → Shopify modal"
  );

  modalButton.click();
}

    media.addEventListener(
      "mouseenter",
      onEnter,
      { passive: true }
    );

    media.addEventListener(
      "mousemove",
      onMove,
      { passive: true }
    );

    media.addEventListener(
      "mouseleave",
      onLeave,
      { passive: true }
    );

    media.addEventListener(
      "click",
      onClick
    );
  }

  function init() {
    addZoomStyles();

    document
      .querySelectorAll(
        ".product__media-wrapper .product__media"
      )
      .forEach(setupImage);
  }

  function observeGallery() {
    const gallery = document.querySelector(
      ".product__media-wrapper"
    );

    if (!gallery) return;

    const observer =
      new MutationObserver(() => {
        init();
      });

    observer.observe(gallery, {
      childList: true,
      subtree: true
    });
  }

  function start() {
    init();
    observeGallery();
  }

  if (document.readyState === "loading") {
    document.addEventListener(
      "DOMContentLoaded",
      start,
      { once: true }
    );
  } else {
    start();
  }

  console.log(
    "✅ NEXCARTA C-03.10 Premium Image Zoom Loaded"
  );
})();
/* ==========================================================
   NEXCARTA C-06 — MOBILE CART DRAWER PORTAL FIX
   Purpose:
   Fix Shopify cart-notification fixed-position issue caused
   by ancestor backdrop-filter / containing-block behavior.
   ========================================================== */

(() => {
  "use strict";

  if (window.nxC06MobileCartPortalLoaded) {
    return;
  }

  window.nxC06MobileCartPortalLoaded = true;

  const DRAWER_SELECTOR = "#cart-notification";
  const MOBILE_QUERY = "(max-width: 749px)";

  let drawer = null;
  let placeholder = null;
  let originalParent = null;
  let originalNextSibling = null;

  /* ----------------------------------------------------------
     FIND DRAWER
     ---------------------------------------------------------- */

  function findDrawer() {
    drawer = document.querySelector(DRAWER_SELECTOR);

    if (!drawer) {
      return false;
    }

    return true;
  }

  /* ----------------------------------------------------------
     CREATE DOM PLACEHOLDER
     ---------------------------------------------------------- */

  function createPlaceholder() {
    if (!drawer) return;

    if (placeholder && placeholder.isConnected) {
      return;
    }

    originalParent = drawer.parentElement;
    originalNextSibling = drawer.nextSibling;

    placeholder = document.createComment(
      "NEXCARTA C-06 cart-notification placeholder"
    );

    if (originalParent) {
      originalParent.insertBefore(
        placeholder,
        drawer
      );
    }
  }

  /* ----------------------------------------------------------
     MOVE DRAWER TO BODY
     ---------------------------------------------------------- */

  function moveToMobilePortal() {
    if (!findDrawer()) {
      return;
    }

    if (!window.matchMedia(MOBILE_QUERY).matches) {
      restoreDesktopPosition();
      return;
    }

    if (drawer.parentElement === document.body) {
      return;
    }

    createPlaceholder();

    document.body.appendChild(drawer);

    console.log(
      "✅ C-06: Cart notification moved to BODY portal"
    );
  }

  /* ----------------------------------------------------------
     RESTORE ORIGINAL DESKTOP POSITION
     ---------------------------------------------------------- */

  function restoreDesktopPosition() {
    if (!drawer) {
      findDrawer();
    }

    if (!drawer) {
      return;
    }

    if (
      !placeholder ||
      !placeholder.parentNode
    ) {
      return;
    }

    if (drawer.parentElement === document.body) {
      placeholder.parentNode.insertBefore(
        drawer,
        placeholder
      );

      console.log(
        "↩️ C-06: Cart notification restored"
      );
    }

    placeholder.remove();
    placeholder = null;

    originalParent = null;
    originalNextSibling = null;
  }

  /* ----------------------------------------------------------
     INITIALIZE
     ---------------------------------------------------------- */

  function initC06() {
    if (!findDrawer()) {
      return;
    }

    moveToMobilePortal();
  }

  /* ----------------------------------------------------------
     RESPONSIVE CHECK
     ---------------------------------------------------------- */

  let resizeFrame = null;

  window.addEventListener(
    "resize",
    () => {
      if (resizeFrame) {
        cancelAnimationFrame(resizeFrame);
      }

      resizeFrame = requestAnimationFrame(() => {
        resizeFrame = null;

        if (
          window.matchMedia(MOBILE_QUERY).matches
        ) {
          moveToMobilePortal();
        } else {
          restoreDesktopPosition();
        }
      });
    },
    { passive: true }
  );

  /* ----------------------------------------------------------
     SHOPIFY DOM RE-RENDER WATCH
     ---------------------------------------------------------- */

  const observer = new MutationObserver(() => {
    if (resizeFrame) {
      return;
    }

    resizeFrame = requestAnimationFrame(() => {
      resizeFrame = null;

      const currentDrawer =
        document.querySelector(DRAWER_SELECTOR);

      if (!currentDrawer) {
        drawer = null;
        return;
      }

      /*
       * Shopify may replace #cart-notification
       * during cart updates.
       */
      if (currentDrawer !== drawer) {
        drawer = currentDrawer;

        /*
         * New Shopify drawer node:
         * recreate portal handling.
         */
        if (
          window.matchMedia(MOBILE_QUERY).matches
        ) {
          placeholder = null;
          originalParent = null;
          originalNextSibling = null;

          moveToMobilePortal();
        }
      } else {
        moveToMobilePortal();
      }
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  /* ----------------------------------------------------------
     START
     ---------------------------------------------------------- */

  if (document.readyState === "loading") {
    document.addEventListener(
      "DOMContentLoaded",
      initC06,
      { once: true }
    );
  } else {
    initC06();
  }

  console.log(
    "✅ NEXCARTA C-06 Mobile Cart Portal Loaded"
  );

})();
/* =========================================================
   NEXCARTA — C-04.3
   SMOOTH 3D PRODUCT POP-OUT
   FINAL / PERMANENT
   ========================================================= */

(() => {
  const selector =
    ".collection .product-grid .card-wrapper";

  const MAX_TILT = 2.2;
  const MAX_Z = 95;
  const MAX_SCALE = 1.055;
  const EASE = 0.14;

  const states = new WeakMap();

  function getState(card) {
    let state = states.get(card);

    if (!state) {
      state = {
        targetX: 0,
        targetY: 0,
        targetZ: 0,
        targetScale: 1,

        currentX: 0,
        currentY: 0,
        currentZ: 0,
        currentScale: 1,

        lightX: 50,
        lightY: 50,

        active: false
      };

      states.set(card, state);
    }

    return state;
  }

  function render(card, state) {
    state.currentX +=
      (state.targetX - state.currentX) * EASE;

    state.currentY +=
      (state.targetY - state.currentY) * EASE;

    state.currentZ +=
      (state.targetZ - state.currentZ) * EASE;

    state.currentScale +=
      (state.targetScale - state.currentScale) * EASE;

    card.style.setProperty(
      "--nx-pop-x",
      state.currentX.toFixed(3) + "deg"
    );

    card.style.setProperty(
      "--nx-pop-y",
      state.currentY.toFixed(3) + "deg"
    );

    card.style.setProperty(
      "--nx-pop-z",
      state.currentZ.toFixed(3) + "px"
    );

    card.style.setProperty(
      "--nx-pop-scale",
      state.currentScale.toFixed(4)
    );

    card.style.setProperty(
      "--nx-light-x",
      state.lightX.toFixed(1) + "%"
    );

    card.style.setProperty(
      "--nx-light-y",
      state.lightY.toFixed(1) + "%"
    );
  }

  function bindCards() {
    document.querySelectorAll(selector).forEach(card => {
      if (card.dataset.nxC043Bound === "true") {
        return;
      }

      card.dataset.nxC043Bound = "true";

      const state = getState(card);

      card.addEventListener("mouseenter", () => {
        state.active = true;

        state.targetZ = MAX_Z;
        state.targetScale = MAX_SCALE;

        card.classList.add("nx-popout");
      });

      card.addEventListener("mousemove", event => {
        const rect = card.getBoundingClientRect();

        if (!rect.width || !rect.height) {
          return;
        }

        const x =
          (event.clientX - rect.left) / rect.width;

        const y =
          (event.clientY - rect.top) / rect.height;

        const px =
          Math.max(-1, Math.min(1, (x - 0.5) * 2));

        const py =
          Math.max(-1, Math.min(1, (y - 0.5) * 2));

        state.targetX = -py * MAX_TILT;
        state.targetY = px * MAX_TILT;

        state.lightX = x * 100;
        state.lightY = y * 100;
      });

      card.addEventListener("mouseleave", () => {
        state.active = false;

        state.targetX = 0;
        state.targetY = 0;
        state.targetZ = 0;
        state.targetScale = 1;

        state.lightX = 50;
        state.lightY = 50;

        setTimeout(() => {
          if (!state.active) {
            card.classList.remove("nx-popout");
          }
        }, 450);
      });
    });
  }

  function animate() {
    document.querySelectorAll(selector).forEach(card => {
      render(card, getState(card));
    });

    requestAnimationFrame(animate);
  }

  bindCards();
  requestAnimationFrame(animate);

  const observer = new MutationObserver(bindCards);

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
})();
/* =========================================================
   NEXCARTA FLASH DEALS — CONTINUOUS 24H COUNTDOWN
   ========================================================= */

(() => {
  const SELECTOR = ".nx-flash-deals";
  const TIMER_KEY = "nexcarta_flash_deals_end";
  const CYCLE_MS = 24 * 60 * 60 * 1000;

  let interval = null;

  function getElements() {
    const bar = document.querySelector(SELECTOR);

    if (!bar) return null;

    const days = bar.querySelector("[data-days]");
    const hours = bar.querySelector("[data-hours]");
    const minutes = bar.querySelector("[data-minutes]");
    const seconds = bar.querySelector("[data-seconds]");

    if (!days || !hours || !minutes || !seconds) {
      return null;
    }

    return {
      bar,
      days,
      hours,
      minutes,
      seconds
    };
  }

  function getEndTime() {
    let end = Number(localStorage.getItem(TIMER_KEY));

    if (!end || !Number.isFinite(end) || end <= Date.now()) {
      end = Date.now() + CYCLE_MS;
      localStorage.setItem(TIMER_KEY, String(end));
    }

    return end;
  }

  function updateCountdown() {
    const els = getElements();

    if (!els) return;

    let remaining = getEndTime() - Date.now();

    if (remaining <= 0) {
      const newEnd = Date.now() + CYCLE_MS;

      localStorage.setItem(TIMER_KEY, String(newEnd));

      remaining = newEnd - Date.now();
    }

    let totalSeconds = Math.floor(remaining / 1000);

    const days = Math.floor(totalSeconds / 86400);

    totalSeconds %= 86400;

    const hours = Math.floor(totalSeconds / 3600);

    totalSeconds %= 3600;

    const minutes = Math.floor(totalSeconds / 60);

    const seconds = totalSeconds % 60;

    els.days.textContent = String(days).padStart(2, "0");
    els.hours.textContent = String(hours).padStart(2, "0");
    els.minutes.textContent = String(minutes).padStart(2, "0");
    els.seconds.textContent = String(seconds).padStart(2, "0");
  }

  function startCountdown() {
    if (interval) {
      clearInterval(interval);
      interval = null;
    }

    const els = getElements();

    if (!els) {
      return;
    }

    updateCountdown();

    interval = setInterval(updateCountdown, 1000);
  }

  function init() {
    startCountdown();
  }

  /* Initial load */
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init, {
      once: true
    });
  } else {
    init();
  }

  /* Shopify Theme Editor / dynamic section reload support */
  document.addEventListener(
    "shopify:section:load",
    () => {
      setTimeout(startCountdown, 50);
    }
  );

  document.addEventListener(
    "shopify:section:reorder",
    () => {
      setTimeout(startCountdown, 50);
    }
  );

  /* If Shopify replaces the Flash Deals DOM dynamically */
  const observer = new MutationObserver(() => {
    const bar = document.querySelector(SELECTOR);

    if (!bar) return;

    if (!bar.dataset.nxCountdownReady) {
      bar.dataset.nxCountdownReady = "true";
      startCountdown();
    }
  });

  if (document.body) {
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  console.log("✅ NEXCARTA Flash Deals Countdown Loaded");
})();
/* =========================================================
   NEXCARTA — INFINITE EXPLORE SLIDERS
   ========================================================= */

(() => {
  const SELECTOR = '.nx-explore-row';

  function initExploreSliders() {
    const rows = document.querySelectorAll(SELECTOR);

    if (!rows.length) return;

    rows.forEach((row, rowIndex) => {
      const track = row.querySelector('.nx-explore-track');

      if (!track) return;

      /* Remove old clones */
      track
        .querySelectorAll(
          '.nx-explore-item[data-nx-clone="true"]'
        )
        .forEach((item) => item.remove());

      const originals = [
        ...track.querySelectorAll(
          '.nx-explore-item'
        )
      ];

      if (!originals.length) return;

      /* Make 4 complete sets */
      for (let set = 1; set < 4; set++) {
        originals.forEach((item) => {
          const clone = item.cloneNode(true);

          clone.dataset.nxClone = 'true';
          clone.setAttribute(
            'aria-hidden',
            'true'
          );
          clone.tabIndex = -1;

          track.appendChild(clone);
        });
      }

      /* Measure one complete original set */
      const first = originals[0];
      const last =
        originals[originals.length - 1];

      if (!first || !last) return;

      const firstRect =
        first.getBoundingClientRect();

      const lastRect =
        last.getBoundingClientRect();

      const trackStyle =
        getComputedStyle(track);

      const gap =
        parseFloat(
          trackStyle.columnGap ||
          trackStyle.gap ||
          '0'
        ) || 0;

      const loopWidth =
        (lastRect.right - firstRect.left) +
        gap * (originals.length - 1);

      track.style.setProperty(
        '--nx-loop-width',
        `${loopWidth}px`
      );

      track.dataset.nxExploreReady = 'true';

      /* Reset animation */
      track.style.animation = 'none';

      void track.offsetWidth;

      track.style.animation =
        rowIndex === 0
          ? 'nxInfiniteLeft 36s linear infinite'
          : 'nxInfiniteRight 36s linear infinite';
    });

    console.log(
      '✅ NEXCARTA Explore Infinite Sliders Loaded'
    );
  }

  if (
    document.readyState === 'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      initExploreSliders,
      { once: true }
    );
  } else {
    initExploreSliders();
  }

  document.addEventListener(
    'shopify:section:load',
    () => {
      setTimeout(
        initExploreSliders,
        100
      );
    }
  );
})();

document.addEventListener('DOMContentLoaded', function () {
  const section = document.querySelector(
    '#shopify-section-template--23777732198640__collection_list_qBRGzD'
  );

  if (!section) return;

  const cards = section.querySelectorAll('.collection-list__item');

  cards.forEach((item) => {
    const link = item.querySelector('a[href]');

    if (!link) return;

    item.addEventListener('click', function (event) {
      // Existing link/button पर double action नहीं
      if (event.target.closest('a,button')) {
        return;
      }

      window.location.href = link.href;
    });
  });
});

 /* =========================================================
   NEXCARTA — TRENDING NOW
   Standalone Collection Tabs
   Products load ONLY after pill click
   Max 8 products
   All = Trending Products
   Second Image Hover
   Existing Premium Sold Out + Discount System
   ========================================================= */

(() => {
  "use strict";

  /* Prevent duplicate initialization if this asset is loaded twice */
  if (window.NEXCARTA_TRENDING_NOW_PERMANENT) return;
  window.NEXCARTA_TRENDING_NOW_PERMANENT = true;

  const SECTION_SELECTOR =
    "#shopify-section-template--23777732198640__custom_liquid_hxrnje";

  const LIMIT = 8;

  const COLLECTIONS = {
    "All": "trending-products",
    "Home & Living": "home-living",
    "Tech & Gadgets": "tech-gadgets",
    "Kitchen": "kitchen",
    "Beauty & Care": "beauty-care",
    "Fashion": "fashion",
    "Gifts": "gifts",
    "Pets": "pets"
  };

  let requestCounter = 0;


  /* =========================================================
     HELPERS
     ========================================================= */

  function cleanText(value) {
    return String(value || "")
      .trim()
      .replace(/\s+/g, " ");
  }


  function escapeHTML(value) {
    return String(value ?? "")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#039;");
  }


  function formatPrice(value) {
    return new Intl.NumberFormat("en-IN", {
      style: "currency",
      currency: "INR",
      maximumFractionDigits: 2
    }).format(Number(value || 0));
  }


  /* =========================================================
     EXISTING NEXCARTA PREMIUM DISCOUNT SYSTEM
     ========================================================= */

  function getDiscountPercent(price, compareAt) {

    const current =
      Number(price || 0);

    const compare =
      Number(compareAt || 0);

    if (
      !compare ||
      compare <= current ||
      !current
    ) {
      return "";
    }

    return Math.round(
      ((compare - current) / compare) * 100
    );
  }


  /* =========================================================
     PRODUCT AREA
     ========================================================= */

  function getProductArea(section) {

    let area =
      section.querySelector(
        ".nx-standalone-products"
      );

    if (area) {
      return area;
    }

    const inner =
      section.querySelector(
        ".nx-trending-now-inner"
      );

    area =
      document.createElement(
        "div"
      );

    area.className =
      "nx-standalone-products";

    area.innerHTML = `
      <div
        class="nx-standalone-products-count"
      ></div>

      <div
        class="nx-standalone-products-grid"
      ></div>

      <div
        class="nx-standalone-view-more-wrap"
      >

        <a
          class="nx-standalone-view-more"
          href="#"
        >
          View More Products
          <span aria-hidden="true">→</span>
        </a>

      </div>
    `;

    if (inner) {

      inner.appendChild(
        area
      );

    } else {

      section.appendChild(
        area
      );

    }

    return area;
  }


  /* =========================================================
     MESSAGE / EMPTY STATE
     ========================================================= */

  function showMessage(
    grid,
    title,
    message
  ) {

    grid.innerHTML = `
      <div class="nx-standalone-empty">

        <strong>
          ${escapeHTML(title)}
        </strong>

        <span>
          ${escapeHTML(message)}
        </span>

      </div>
    `;
  }


  /* =========================================================
     RENDER PRODUCTS
     ========================================================= */

  function renderProducts(
    grid,
    products,
    label
  ) {

    grid.innerHTML = "";

    products
      .slice(0, LIMIT)
      .forEach(
        product => {

          const variant =
            product.variants?.[0] || {};


          /* ---------- PRIMARY IMAGE ---------- */

          const primaryImage =
            product.images?.[0]?.src ||
            product.featured_image?.src ||
            "";


          /* ---------- SECOND IMAGE ---------- */

          const secondaryImage =
            product.images?.[1]?.src ||
            "";


          /* ---------- TITLE ---------- */

          const title =
            escapeHTML(
              product.title
            );


          /* ---------- PRODUCT HANDLE ---------- */

          const handle =
            encodeURIComponent(
              product.handle || ""
            );


          /* ---------- CURRENT PRICE ---------- */

          const currentPrice =
            Number(
              variant.price || 0
            );

          const price =
            formatPrice(
              currentPrice
            );


          /* ---------- COMPARE PRICE ---------- */

          const comparePrice =
            Number(
              variant.compare_at_price || 0
            );


          /* ---------- SALE CHECK ---------- */

          const hasSale =
            comparePrice >
            currentPrice;


          /* ---------- SOLD OUT ---------- */

          const soldOut =
            variant.available === false;


          /* ---------- DISCOUNT ---------- */

          const discountPercent =
            getDiscountPercent(
              currentPrice,
              comparePrice
            );


          /* ---------- CARD ---------- */

          const card =
            document.createElement(
              "article"
            );

          card.className =
            "nx-test-product-card";


          if (secondaryImage) {

            card.classList.add(
              "has-secondary-image"
            );

          }


          /* =====================================================
             CARD HTML
             ===================================================== */

          card.innerHTML = `

            <div
              class="nx-product-collection-label"
            >

              ${
                label === "All"
                  ? "Trending Products"
                  : escapeHTML(label)
              }

            </div>


            <a
              class="nx-test-product-link"
              href="/products/${handle}"
            >

              <div
                class="nx-test-product-image"
              >

                ${
                  primaryImage
                    ? `
                      <img
                        class="nx-primary-image"
                        src="${escapeHTML(primaryImage)}"
                        alt="${title}"
                        loading="lazy"
                      >
                    `
                    : ""
                }


                ${
                  secondaryImage
                    ? `
                      <img
                        class="nx-hover-secondary"
                        src="${escapeHTML(secondaryImage)}"
                        alt="${title} alternate image"
                        loading="lazy"
                      >
                    `
                    : ""
                }


                ${
                  soldOut
                    ? `
                      <div
                        class="nexcarta-badges"
                      >

                        <span
                          class="nexcarta-badge badge-sold-out"
                        >
                          Sold Out
                        </span>

                      </div>
                    `
                    : ""
                }

              </div>


              <div
                class="nx-test-product-info"
              >

                <h3
                  class="nx-test-product-title"
                >
                  ${title}
                </h3>


                <div
                  class="nx-test-product-price"
                >

                  <span
                    class="nx-test-price"
                  >
                    ${price}
                  </span>


                  ${
                    discountPercent
                      ? `
                        <span
                          class="nexcarta-price-discount"
                        >
                          ${discountPercent}%
                        </span>
                      `
                      : ""
                  }


                  ${
                    hasSale
                      ? `
                        <span
                          class="nx-test-compare"
                        >
                          <s>
                            ${formatPrice(comparePrice)}
                          </s>
                        </span>
                      `
                      : ""
                  }

                </div>

              </div>

            </a>

          `;


          /* =====================================================
             SECOND IMAGE HOVER
             ===================================================== */

          if (
            secondaryImage
          ) {

            const imageBox =
              card.querySelector(
                ".nx-test-product-image"
              );


            const primary =
              card.querySelector(
                ".nx-primary-image"
              );


            const secondary =
              card.querySelector(
                ".nx-hover-secondary"
              );


            if (
              imageBox &&
              primary &&
              secondary
            ) {

              imageBox.addEventListener(
                "mouseenter",
                () => {

                  primary.style.opacity =
                    "0";

                  secondary.style.opacity =
                    "1";

                }
              );


              imageBox.addEventListener(
                "mouseleave",
                () => {

                  primary.style.opacity =
                    "1";

                  secondary.style.opacity =
                    "0";

                }
              );

            }

          }


          grid.appendChild(
            card
          );

        }
      );
  }


  /* =========================================================
     LOAD COLLECTION
     ========================================================= */

  async function loadCollection(
    label,
    area
  ) {

    const handle =
      COLLECTIONS[label];

    if (!handle) {
      return;
    }


    const grid =
      area.querySelector(
        ".nx-standalone-products-grid"
      );


    const count =
      area.querySelector(
        ".nx-standalone-products-count"
      );


    const viewMore =
      area.querySelector(
        ".nx-standalone-view-more"
      );


    const requestId =
      ++requestCounter;


    area.style.display =
      "block";


    count.textContent =
      "Loading...";


    viewMore.href =
      `/collections/${handle}`;


    showMessage(
      grid,
      "Loading products...",
      "Please wait."
    );


    try {

      const response =
        await fetch(
          `/collections/${handle}/products.json?limit=250`,
          {
            cache: "no-store"
          }
        );


      if (!response.ok) {

        throw new Error(
          `HTTP ${response.status}`
        );

      }


      const data =
        await response.json();


      if (
        requestId !==
        requestCounter
      ) {

        return;

      }


      const products =
        Array.isArray(
          data.products
        )
          ? data.products
          : [];


      count.textContent =
        `${products.length} product${
          products.length === 1
            ? ""
            : "s"
        }`;


      if (!products.length) {

        viewMore.style.display =
          "none";


        showMessage(
          grid,
          label,
          "Is collection mein abhi products available nahi hain."
        );


        return;

      }


      viewMore.style.display =
        "inline-flex";


      renderProducts(
        grid,
        products,
        label
      );


      console.log(
        `✅ ${label} loaded: ${products.length} products`
      );

    } catch (error) {

      console.error(
        "❌ NEXCARTA Trending Now Error:",
        error
      );


      count.textContent =
        "";


      viewMore.style.display =
        "none";


      showMessage(
        grid,
        "Unable to load products",
        "Please try again."
      );

    }

  }


  /* =========================================================
     INITIALIZE
     ========================================================= */

  function initTrendingNow() {

    const section =
      document.querySelector(
        SECTION_SELECTOR
      );


    if (!section) {
      return;
    }


    const pills =
      [
        ...section.querySelectorAll(
          ".nx-trend-pill"
        )
      ];


    if (!pills.length) {
      return;
    }


    const area =
      getProductArea(
        section
      );


    /* Products hidden until user clicks a pill */

    area.style.display =
      "none";


    /* =======================================================
       PILL EVENTS
       ======================================================= */

    pills.forEach(
      pill => {

        if (
          pill.dataset
            .nxStandaloneBound ===
          "true"
        ) {

          return;

        }


        const label =
          cleanText(
            pill.textContent
          );


        if (
          !COLLECTIONS[label]
        ) {

          return;

        }


        pill.dataset
          .nxStandaloneBound =
          "true";


        pill.addEventListener(
          "click",
          event => {

            event.preventDefault();


            pills.forEach(
              item => {

                item.classList.remove(
                  "is-active"
                );

              }
            );


            pill.classList.add(
              "is-active"
            );


            loadCollection(
              label,
              area
            );

          }
        );

      }
    );


    /* =======================================================
       DEFAULT ACTIVE = ALL
       ======================================================= */

    pills.forEach(
      pill => {

        pill.classList.remove(
          "is-active"
        );

      }
    );


    const allPill =
      pills.find(
        pill =>
          cleanText(
            pill.textContent
          ) === "All"
      );


    if (allPill) {

      allPill.classList.add(
        "is-active"
      );

    }


    /* IMPORTANT:
       All collection is NOT auto-loaded.
       Products appear after pill click. */


    console.log(
      "✅ NEXCARTA Trending Now permanent JS ready"
    );

  }


  /* =========================================================
     DOM READY
     ========================================================= */

  if (
    document.readyState ===
    "loading"
  ) {

    document.addEventListener(
      "DOMContentLoaded",
      initTrendingNow,
      {
        once: true
      }
    );

  } else {

    initTrendingNow();

  }


  /* =========================================================
     SHOPIFY SECTION LOAD
     ========================================================= */

  document.addEventListener(
    "shopify:section:load",
    event => {

      if (
        event?.detail?.sectionId &&
        event.detail.sectionId !==
        "custom_liquid_hxrnje"
      ) {

        return;

      }


      setTimeout(
        initTrendingNow,
        150
      );

    }
  );

})();
/* =========================================================
   NEXCARTA — NEW ARRIVAL
   Remove duplicate Shopify Sold Out badges
   Keep NEXCARTA Premium Sold Out badge
   ========================================================= */

(() => {
  "use strict";

  const SECTION_SELECTOR =
    "#shopify-section-template--23777732198640__featured_collection_febV9V";

  function removeDuplicateShopifySoldOut() {

    const section =
      document.querySelector(
        SECTION_SELECTOR
      );

    if (!section) {
      return;
    }

    const defaultBadges = [
      ...section.querySelectorAll(
        ".card__badge .badge.badge--bottom-left"
      )
    ].filter(
      badge =>
        badge.textContent
          .trim()
          .toLowerCase()
          .includes("sold out")
    );

    defaultBadges.forEach(
      badge => {
        badge.remove();
      }
    );
  }


  /* Initial run */
  if (
    document.readyState ===
    "loading"
  ) {

    document.addEventListener(
      "DOMContentLoaded",
      removeDuplicateShopifySoldOut,
      {
        once: true
      }
    );

  } else {

    removeDuplicateShopifySoldOut();

  }


  /* Shopify section re-render protection */
  document.addEventListener(
    "shopify:section:load",
    event => {

      if (
        event?.detail?.sectionId &&
        event.detail.sectionId !==
          "featured_collection_febV9V"
      ) {
        return;
      }

      setTimeout(
        removeDuplicateShopifySoldOut,
        100
      );

    }
  );


  /* Watch for Shopify/theme DOM changes */
  const observer =
    new MutationObserver(() => {

      removeDuplicateShopifySoldOut();

    });


  observer.observe(
    document.body,
    {
      childList: true,
      subtree: true
    }
  );

})();

(() => {
  "use strict";

  const SECTION_ID =
    "shopify-section-template--23777732198640__featured_collection_UAKFYi";

  function addBestSellersViewMore() {
    const section = document.getElementById(SECTION_ID);

    if (!section) return;

    if (section.querySelector(".nx-bs-view-more")) return;

    const slider =
      section.querySelector("slider-component") ||
      section.querySelector(".slider-component");

    const button = document.createElement("div");

    button.className = "nx-bs-view-more";

    button.innerHTML = `
      <a
        href="/collections/best-sellers"
        aria-label="View More Products"
      >
        <span>View More Products</span>
        <span class="nx-bs-arrow">→</span>
      </a>
    `;

    if (slider) {
      slider.insertAdjacentElement("afterend", button);
      return;
    }

    const collection = section.querySelector(".collection");

    if (collection) {
      collection.appendChild(button);
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener(
      "DOMContentLoaded",
      addBestSellersViewMore,
      { once:true }
    );
  } else {
    addBestSellersViewMore();
  }

  document.addEventListener(
    "shopify:section:load",
    (event) => {
      if (
        event?.detail?.sectionId ===
        "featured_collection_UAKFYi"
      ) {
        setTimeout(addBestSellersViewMore,100);
      }
    }
  );

  const observer = new MutationObserver(() => {
    addBestSellersViewMore();
  });

  observer.observe(document.body,{
    childList:true,
    subtree:true
  });

})();
/* =========================================================
   NEXCARTA — PREMIUM PRODUCT IMAGE HOVER ZOOM
   InspireUplift-style right-side live magnification
   ========================================================= */

(() => {
  'use strict';

  /* =======================================================
     CONFIG
     ======================================================= */

  const CONFIG = {
    minDesktopWidth: 1100,

    panelWidth: 440,
    panelHeight: 440,

    lensSize: 110,

    zoom: 2.15,

    panelGap: 22,

    panelRadius: 8
  };

  /* =======================================================
     CLEAN PREVIOUS NEXCARTA ZOOM INSTANCE
     ======================================================= */

  if (window.NEXCARTAProductZoom &&
      typeof window.NEXCARTAProductZoom.destroy === 'function') {
    window.NEXCARTAProductZoom.destroy();
  }

  /* =======================================================
     SELECTORS
     ======================================================= */

  const IMAGE_SELECTOR =
    'media-gallery .product__media-item.is-active img.image-magnify-lightbox';

  /* =======================================================
     STATE
     ======================================================= */

  let currentImage = null;
  let currentSource = '';

  let animationFrame = null;
  let lastMouseEvent = null;

  let destroyed = false;

  /* =======================================================
     STYLE
     ======================================================= */

  const style = document.createElement('style');

  style.id = 'nexcarta-product-zoom-style';

  style.textContent = `
    @media (min-width: ${CONFIG.minDesktopWidth}px) {

      #nexcarta-product-zoom-panel {
        position: fixed;

        width: ${CONFIG.panelWidth}px;
        height: ${CONFIG.panelHeight}px;

        overflow: hidden;

        display: none;

        background: #ffffff;

        border:
          1px solid rgba(181,145,78,.42);

        border-radius:
          ${CONFIG.panelRadius}px;

        box-shadow:
          0 20px 55px rgba(0,0,0,.18);

        z-index: 2147483645;

        pointer-events: none;

        box-sizing: border-box;
      }

      #nexcarta-product-zoom-panel img {
        position: absolute;

        display: block;

        max-width: none !important;

        width: auto !important;
        height: auto !important;

        pointer-events: none;

        user-select: none;

        -webkit-user-drag: none;
      }

      #nexcarta-product-zoom-lens {
        position: fixed;

        width: ${CONFIG.lensSize}px;
        height: ${CONFIG.lensSize}px;

        display: none;

        pointer-events: none;

        z-index: 2147483646;

        box-sizing: border-box;

        border:
          1px solid rgba(181,145,78,.88);

        background:
          rgba(181,145,78,.045);

        box-shadow:
          0 0 0 1px rgba(255,255,255,.45),
          inset 0 0 0 1px rgba(181,145,78,.12);
      }

      #nexcarta-product-zoom-panel::before {
        content: "PRODUCT DETAIL";

        position: absolute;

        left: 14px;
        bottom: 12px;

        padding: 6px 9px;

        color: rgba(255,255,255,.9);

        background:
          rgba(15,15,15,.48);

        border-radius: 4px;

        font:
          500 9px/1
          Arial,
          Helvetica,
          sans-serif;

        letter-spacing: 1.4px;

        z-index: 2;

        backdrop-filter: blur(5px);
        -webkit-backdrop-filter: blur(5px);
      }
    }

    @media (max-width: ${CONFIG.minDesktopWidth - 1}px) {

      #nexcarta-product-zoom-panel,
      #nexcarta-product-zoom-lens {
        display: none !important;
      }
    }
  `;

  document.head.appendChild(style);

  /* =======================================================
     CREATE ZOOM PANEL
     ======================================================= */

  const panel = document.createElement('div');

  panel.id = 'nexcarta-product-zoom-panel';

  const zoomImage = document.createElement('img');

  zoomImage.alt = '';

  zoomImage.decoding = 'async';

  zoomImage.loading = 'eager';

  panel.appendChild(zoomImage);

  /* =======================================================
     CREATE LENS
     ======================================================= */

  const lens = document.createElement('div');

  lens.id = 'nexcarta-product-zoom-lens';

  /* =======================================================
     APPEND
     ======================================================= */

  document.body.appendChild(panel);
  document.body.appendChild(lens);

  /* =======================================================
     FIND ACTIVE IMAGE
     ======================================================= */

  function getActiveImage() {
    return document.querySelector(IMAGE_SELECTOR);
  }

  /* =======================================================
     HIGH-RES IMAGE SOURCE
     ======================================================= */

  function getHighResolutionSource(img) {

    if (!img) {
      return '';
    }

    let src =
      img.currentSrc ||
      img.src ||
      '';

    if (!src) {
      return '';
    }

    /*
      Shopify CDN:
      Convert width parameter to a high-resolution source.
    */

    if (/width=\\d+/i.test(src)) {

      src = src.replace(
        /width=\\d+/i,
        'width=2048'
      );

    } else {

      src +=
        (src.includes('?') ? '&' : '?') +
        'width=2048';
    }

    return src;
  }

  /* =======================================================
     UPDATE ACTIVE IMAGE
     ======================================================= */

  function updateImageReference() {

    const img = getActiveImage();

    if (!img) {
      currentImage = null;
      currentSource = '';
      return;
    }

    currentImage = img;

    const source =
      getHighResolutionSource(img);

    if (
      source &&
      source !== currentSource
    ) {

      currentSource = source;

      zoomImage.src = source;
    }
  }

  /* =======================================================
     CHECK DESKTOP
     ======================================================= */

  function isDesktop() {

    return window.innerWidth >=
      CONFIG.minDesktopWidth;
  }

  /* =======================================================
     HIDE ZOOM
     ======================================================= */

  function hideZoom() {

    panel.style.display = 'none';

    lens.style.display = 'none';
  }

  /* =======================================================
     POSITION ZOOM PANEL
     ======================================================= */

  function positionPanel(rect) {

    const panelWidth =
      CONFIG.panelWidth;

    const panelHeight =
      CONFIG.panelHeight;

    const gap =
      CONFIG.panelGap;

    /*
      Prefer right side.
    */

    let left =
      rect.right + gap;

    let top =
      rect.top;

    /*
      If right side doesn't fit,
      use left side as fallback.
    */

    if (
      left + panelWidth >
      window.innerWidth - 12
    ) {

      left =
        rect.left -
        panelWidth -
        gap;
    }

    /*
      Keep vertically inside viewport.
    */

    if (
      top + panelHeight >
      window.innerHeight - 12
    ) {

      top =
        window.innerHeight -
        panelHeight -
        12;
    }

    if (top < 12) {
      top = 12;
    }

    panel.style.left =
      `${Math.round(left)}px`;

    panel.style.top =
      `${Math.round(top)}px`;
  }

  /* =======================================================
     CALCULATE ZOOM
     ======================================================= */

  function updateZoom(e) {

    if (!isDesktop()) {

      hideZoom();

      return;
    }

    const img =
      getActiveImage();

    if (!img) {

      hideZoom();

      return;
    }

    /*
      Refresh source if Shopify changed
      the active product image.
    */

    if (img !== currentImage) {

      updateImageReference();
    }

    const rect =
      img.getBoundingClientRect();

    if (
      rect.width < 150 ||
      rect.height < 150
    ) {

      hideZoom();

      return;
    }

    /*
      Is mouse actually inside image?
    */

    const inside =
      e.clientX >= rect.left &&
      e.clientX <= rect.right &&
      e.clientY >= rect.top &&
      e.clientY <= rect.bottom;

    if (!inside) {

      hideZoom();

      return;
    }

    /*
      Mouse position inside image.
    */

    const x =
      e.clientX -
      rect.left;

    const y =
      e.clientY -
      rect.top;

    /*
      Convert to percentage.
    */

    const xPercent =
      Math.max(
        0,
        Math.min(
          1,
          x / rect.width
        )
      );

    const yPercent =
      Math.max(
        0,
        Math.min(
          1,
          y / rect.height
        )
      );

    /* =====================================================
       PANEL
       ===================================================== */

    positionPanel(rect);

    panel.style.display =
      'block';

    /*
      Zoom image dimensions.
    */

    const zoomWidth =
      rect.width *
      CONFIG.zoom;

    const zoomHeight =
      rect.height *
      CONFIG.zoom;

    zoomImage.style.width =
      `${zoomWidth}px`;

    zoomImage.style.height =
      `${zoomHeight}px`;

    /*
      Maximum image movement.
    */

    const maxMoveX =
      Math.max(
        0,
        zoomWidth -
        CONFIG.panelWidth
      );

    const maxMoveY =
      Math.max(
        0,
        zoomHeight -
        CONFIG.panelHeight
      );

    /*
      Keep cursor area centered
      inside zoom panel.
    */

    const imageLeft =
      -(xPercent * maxMoveX);

    const imageTop =
      -(yPercent * maxMoveY);

    zoomImage.style.left =
      `${imageLeft}px`;

    zoomImage.style.top =
      `${imageTop}px`;

    /* =====================================================
       LENS
       ===================================================== */

    const halfLens =
      CONFIG.lensSize / 2;

    lens.style.left =
      `${e.clientX - halfLens}px`;

    lens.style.top =
      `${e.clientY - halfLens}px`;

    lens.style.display =
      'block';
  }

  /* =======================================================
     MOUSEMOVE — DOCUMENT LEVEL
     ======================================================= */

  function onMouseMove(e) {

    if (destroyed) {
      return;
    }

    lastMouseEvent = e;

    /*
      Prevent excessive DOM calculations.
    */

    if (animationFrame) {
      return;
    }

    animationFrame =
      requestAnimationFrame(() => {

        animationFrame = null;

        if (lastMouseEvent) {

          updateZoom(
            lastMouseEvent
          );
        }

      });
  }

  document.addEventListener(
    'mousemove',
    onMouseMove,
    { passive: true }
  );

  /* =======================================================
     MOUSE LEAVE WINDOW
     ======================================================= */

  function onMouseLeave() {
    hideZoom();
  }

  document.addEventListener(
    'mouseleave',
    onMouseLeave
  );

  /* =======================================================
     RESIZE
     ======================================================= */

  function onResize() {

    if (!isDesktop()) {

      hideZoom();

      return;
    }

    updateImageReference();

    if (
      panel.style.display ===
      'block'
    ) {

      const img =
        getActiveImage();

      if (img) {

        positionPanel(
          img.getBoundingClientRect()
        );
      }
    }
  }

  window.addEventListener(
    'resize',
    onResize,
    { passive: true }
  );

  /* =======================================================
     SHOPIFY DYNAMIC GALLERY WATCHER
     ======================================================= */

  const gallery =
    document.querySelector('media-gallery');

  let observer = null;

  if (gallery) {

    observer =
      new MutationObserver(() => {

        updateImageReference();

      });

    observer.observe(
      gallery,
      {
        subtree: true,
        childList: true,
        attributes: true,

        attributeFilter: [
          'class',
          'src',
          'srcset'
        ]
      }
    );
  }

  /* =======================================================
     INITIAL IMAGE
     ======================================================= */

  updateImageReference();

  /* =======================================================
     PUBLIC DESTROY
     ======================================================= */

  window.NEXCARTAProductZoom = {

    destroy() {

      destroyed = true;

      document.removeEventListener(
        'mousemove',
        onMouseMove
      );

      document.removeEventListener(
        'mouseleave',
        onMouseLeave
      );

      window.removeEventListener(
        'resize',
        onResize
      );

      if (observer) {
        observer.disconnect();
      }

      if (animationFrame) {
        cancelAnimationFrame(
          animationFrame
        );
      }

      panel.remove();
      lens.remove();
      style.remove();

      delete window.NEXCARTAProductZoom;
    }
  };

  /* =======================================================
     READY
     ======================================================= */

  console.log(
    '%cNEXCARTA PRODUCT ZOOM ACTIVE',
    'font-weight:bold;font-size:14px;color:#b8944b;'
  );

})();
/* =========================================================
   NEXCARTA — PREMIUM FOOTER ADDITIONS
   ADD-ONLY / DUPLICATE SAFE

   01. NEXCARTA BRAND BLOCK
   02. NEED HELP SUPPORT STRIP
   03. LIVE CHAT + EMAIL + WE ACCEPT
   ========================================================= */

(() => {
  'use strict';

  /* =======================================================
     CONFIG
     ======================================================= */

  const FOOTER_SELECTOR =
    '#shopify-section-sections--23777732428016__footer';

  const BRAND_ID =
    'nx-footer-brand-test';

  const SUPPORT_ID =
    'nx-contact-strip-test';

  const PAYMENT_ID =
    'nx-contact-payment-test';

  /* =======================================================
     GET FOOTER
     ======================================================= */

  function getFooter() {
    return document.querySelector(FOOTER_SELECTOR);
  }

  /* =======================================================
     CREATE NEXCARTA BRAND BLOCK
     ======================================================= */

  function addBrandBlock(footer) {

    if (document.getElementById(BRAND_ID)) {
      return;
    }

    const contentTop =
      footer.querySelector('.footer__content-top');

    if (!contentTop) {
      return;
    }

    const brand =
      document.createElement('div');

    brand.id = BRAND_ID;

    brand.innerHTML = `
      <div class="nx-footer-brand-inner">

        <div class="nx-footer-brand-name">
          NEXCARTA
        </div>

        <div class="nx-footer-brand-tagline">
          Smart products. Better everyday living.
        </div>

        <div class="nx-footer-brand-divider"></div>

      </div>
    `;

    contentTop.parentNode.insertBefore(
      brand,
      contentTop
    );
  }

  /* =======================================================
     CREATE NEED HELP STRIP
     ======================================================= */

  function addSupportStrip(footer) {

    if (document.getElementById(SUPPORT_ID)) {
      return;
    }

    const contentTop =
      footer.querySelector('.footer__content-top');

    if (!contentTop) {
      return;
    }

    const support =
      document.createElement('div');

    support.id = SUPPORT_ID;

    support.innerHTML = `
      <div class="nx-contact-strip-inner">

        <div class="nx-contact-intro">

          <span class="nx-contact-label">
            NEED HELP?
          </span>

          <strong>
            We're here for you.
          </strong>

        </div>


        <div class="nx-contact-links">

          <a href="/pages/faq">
            <span>FAQ</span>
            <b>→</b>
          </a>

          <a href="/pages/shipping-policy">
            <span>Shipping</span>
            <b>→</b>
          </a>

          <a href="/pages/refund-return-policy">
            <span>Returns</span>
            <b>→</b>
          </a>

          <a href="/pages/faq">
            <span>Contact Us</span>
            <b>→</b>
          </a>

        </div>


        <button
          type="button"
          class="nx-back-top"
          aria-label="Back to top">

          ↑ Back to top

        </button>

      </div>
    `;

    /*
      Insert after NEXCARTA brand block.
    */

    const brand =
      document.getElementById(BRAND_ID);

    if (brand) {

      brand.after(support);

    } else {

      contentTop.before(support);
    }

    /* Back to top */

    const backTop =
      support.querySelector('.nx-back-top');

    if (backTop) {

      backTop.addEventListener(
        'click',
        () => {

          window.scrollTo({
            top: 0,
            behavior: 'smooth'
          });

        }
      );
    }
  }

  /* =======================================================
     CREATE LIVE CHAT + EMAIL + PAYMENT ROW
     ======================================================= */

  function addContactPaymentRow(footer) {

    if (document.getElementById(PAYMENT_ID)) {
      return;
    }

    const bottom =
      footer.querySelector(
        '.footer__content-bottom'
      );

    if (!bottom) {
      return;
    }

    const row =
      document.createElement('div');

    row.id = PAYMENT_ID;

    row.innerHTML = `

      <div class="nx-cp-inner">

        <!-- =========================================
             24/7 LIVE CHAT
             ========================================= -->

        <div class="nx-cp-contact">

          <span
            class="nx-cp-chat-icon"
            aria-hidden="true">

            <svg
              viewBox="0 0 24 24"
              fill="none">

              <path
                d="M4 5.5A3.5 3.5 0 0 1 7.5 2h9A3.5 3.5 0 0 1 20 5.5v6A3.5 3.5 0 0 1 16.5 15H11l-4.2 3v-3.15A3.5 3.5 0 0 1 4 11.5v-6Z"
                stroke="currentColor"
                stroke-width="1.5"
                stroke-linejoin="round"
              />

            </svg>

          </span>


          <span>

            <strong>
              24/7 Live Chat
            </strong>

            <small>
              We're here to help
            </small>

          </span>

        </div>


        <!-- =========================================
             EMAIL
             ========================================= -->

        <a
          class="nx-cp-email"
          href="mailto:nexcartastore@gmail.com"
          aria-label="Email NEXCARTA">

          <span
            class="nx-cp-mail-icon"
            aria-hidden="true">

            <svg
              viewBox="0 0 24 24"
              fill="none">

              <rect
                x="3"
                y="5"
                width="18"
                height="14"
                rx="2"
                stroke="currentColor"
                stroke-width="1.5"
              />

              <path
                d="m4 7 8 6 8-6"
                stroke="currentColor"
                stroke-width="1.5"
                stroke-linejoin="round"
              />

            </svg>

          </span>

          <span>
            nexcartastore@gmail.com
          </span>

        </a>


        <!-- =========================================
             WE ACCEPT
             ========================================= -->

        <div class="nx-cp-payments">

          <span class="nx-cp-payment-title">
            We Accept
          </span>


          <div class="nx-cp-payment-icons">

            <!-- VISA -->

            <svg
              class="nx-pay-svg"
              viewBox="0 0 64 38"
              aria-label="Visa"
              role="img">

              <rect
                x=".5"
                y=".5"
                width="63"
                height="37"
                rx="7"
                fill="#fff"
                stroke="currentColor"
                opacity=".32"
              />

              <text
                x="32"
                y="24"
                text-anchor="middle"
                font-size="13"
                font-weight="700"
                font-family="Arial,sans-serif"
                font-style="italic"
                fill="currentColor">

                VISA

              </text>

            </svg>


            <!-- MASTERCARD -->

            <svg
              class="nx-pay-svg"
              viewBox="0 0 64 38"
              aria-label="Mastercard"
              role="img">

              <rect
                x=".5"
                y=".5"
                width="63"
                height="37"
                rx="7"
                fill="#fff"
                stroke="currentColor"
                opacity=".32"
              />

              <circle
                cx="27"
                cy="19"
                r="8"
                fill="#b9954d"
                opacity=".85"
              />

              <circle
                cx="37"
                cy="19"
                r="8"
                fill="#d9bd82"
                opacity=".85"
              />

            </svg>


            <!-- AMEX -->

            <svg
              class="nx-pay-svg"
              viewBox="0 0 64 38"
              aria-label="American Express"
              role="img">

              <rect
                x=".5"
                y=".5"
                width="63"
                height="37"
                rx="7"
                fill="#fff"
                stroke="currentColor"
                opacity=".32"
              />

              <text
                x="32"
                y="22.5"
                text-anchor="middle"
                font-size="9"
                font-weight="700"
                font-family="Arial,sans-serif"
                fill="currentColor">

                AMEX

              </text>

            </svg>


            <!-- UPI -->

            <svg
              class="nx-pay-svg"
              viewBox="0 0 64 38"
              aria-label="UPI"
              role="img">

              <rect
                x=".5"
                y=".5"
                width="63"
                height="37"
                rx="7"
                fill="#fff"
                stroke="currentColor"
                opacity=".32"
              />

              <text
                x="32"
                y="23"
                text-anchor="middle"
                font-size="12"
                font-weight="700"
                font-family="Arial,sans-serif"
                fill="currentColor">

                UPI

              </text>

            </svg>

          </div>

        </div>

      </div>
    `;

    /*
      Insert immediately above existing legal bar.
    */

    bottom.parentNode.insertBefore(
      row,
      bottom
    );
  }

  /* =======================================================
     INITIALIZE
     ======================================================= */

  function initFooterAdditions() {

    const footer =
      getFooter();

    if (!footer) {
      return false;
    }

    addBrandBlock(footer);

    addSupportStrip(footer);

    addContactPaymentRow(footer);

    return true;
  }

  /* =======================================================
     WAIT FOR SHOPIFY FOOTER
     ======================================================= */

  function start() {

    if (initFooterAdditions()) {
      return;
    }

    /*
      In case Shopify/theme loads
      footer after initial DOM ready.
    */

    const observer =
      new MutationObserver(() => {

        if (initFooterAdditions()) {

          observer.disconnect();
        }

      });

    observer.observe(
      document.documentElement,
      {
        childList: true,
        subtree: true
      }
    );

    /*
      Safety cleanup
    */

    setTimeout(() => {
      observer.disconnect();
    }, 10000);
  }

  /* =======================================================
     START
     ======================================================= */

  if (
    document.readyState === 'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      start,
      { once: true }
    );

  } else {

    start();
  }

})();
(function () {
  function initNexcarta3DIntro() {
    const intro = document.querySelector("[data-nx3d-intro]");

    if (!intro || intro.dataset.ready === "true") return;

    intro.dataset.ready = "true";

    const skip = intro.querySelector("[data-nx3d-skip]");
    const progress = intro.querySelector("[data-nx3d-progress]");

    const key = "nexcarta-3d-intro-seen-v1";

    const editor =
      window.Shopify &&
      window.Shopify.designMode === true;

    let startTime = null;
    let animationFrame = null;

    function seen() {
      try {
        return sessionStorage.getItem(key) === "1";
      } catch (e) {
        return false;
      }
    }

    function markSeen() {
      try {
        sessionStorage.setItem(key, "1");
      } catch (e) {}
    }

    function closeIntro() {
      markSeen();

      intro.classList.remove("is-active");
      intro.classList.add("is-closing");

      document.documentElement.classList.remove("nx3d-lock");

      cancelAnimationFrame(animationFrame);

      window.setTimeout(function () {
        intro.remove();
      }, 850);
    }

    if (!editor && seen()) {
      intro.remove();
      return;
    }

    intro.classList.add("is-active");
    intro.setAttribute("aria-hidden", "false");
    document.documentElement.classList.add("nx3d-lock");

    skip.addEventListener("click", closeIntro);

    function animate(time) {
      if (!startTime) startTime = time;

      const elapsed = time - startTime;
      const percent = Math.min((elapsed / 6500) * 100, 100);

      if (progress) {
        progress.style.width = percent + "%";
      }

      if (elapsed >= 6500) {
        closeIntro();
        return;
      }

      animationFrame = requestAnimationFrame(animate);
    }

    animationFrame = requestAnimationFrame(animate);
  }

  if (document.readyState === "loading") {
    document.addEventListener(
      "DOMContentLoaded",
      initNexcarta3DIntro
    );
  } else {
    initNexcarta3DIntro();
  }
})();